import React from "react";
import { useBookingAppointmentTypeStore } from "../../../hooks";
import { CREATE_BOOKING_TYPE } from "../../../config/params";
import AvailableTimeSlots from "../../../components/AvailableTimeSlots/AvailableTimeSlots";

const BookingScheduleContainer = () => {
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();


  return (
    <>
      <div className="w-full h-full flex flex-col justify-between ">
        <div className="flex-grow w-full flex px-2">
          <AvailableTimeSlots
            title="Available times"
            isCarousal={false}
            isDropoff={(bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING) ? true : false}
          />
        </div>
      </div>
    </>
  );
};

export default BookingScheduleContainer;
